// extracted by mini-css-extract-plugin
export default {"contentWrapper":"genericScreen_contentWrapper__GXqyE","actionsWrapper":"genericScreen_actionsWrapper__qcAZH","suppressZerosCheckbox":"genericScreen_suppressZerosCheckbox__+d5LZ"};